import { render, staticRenderFns } from "./Nationality.vue?vue&type=template&id=1a812cf4&scoped=true"
import script from "./Nationality.vue?vue&type=script&lang=js"
export * from "./Nationality.vue?vue&type=script&lang=js"
import style0 from "./Nationality.vue?vue&type=style&index=0&id=1a812cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a812cf4",
  null
  
)

export default component.exports